import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFileVideo = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m17.986 6.283-2.578-2.624A2.2 2.2 0 0 0 13.844 3H7.58c-1.221 0-2.21 1.007-2.21 2.25v13.5c0 1.242.99 2.25 2.21 2.25h8.842c1.216 0 2.21-1.012 2.21-2.25V7.873c0-.594-.23-1.168-.645-1.59M16.974 18.75c0 .31-.248.563-.553.563H7.58a.56.56 0 0 1-.553-.563V5.255c0-.311.247-.563.552-.563h5.526V7.5c0 .621.495 1.125 1.105 1.125h2.733V18.75zm-3.316-5.625c0-.621-.495-1.125-1.105-1.125H9.237c-.61 0-1.105.504-1.105 1.125V16.5c0 .621.495 1.125 1.105 1.125h3.316c.61 0 1.105-.504 1.105-1.125v-.58l1.514 1.06a.442.442 0 0 0 .696-.36v-3.615a.443.443 0 0 0-.696-.362l-1.514 1.062z"
    }));
export default SvgFileVideo;
